const partners = {
  userRefs: ['Users', 'UsersSDE', 'UsersBB'],
};

export default partners;
